"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _iterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _json8Patch = _interopRequireDefault(require("json8-patch"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator2["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var createShortId = function createShortId() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  // eslint-disable-line no-magic-numbers
  return Math.random().toString(36).substring(2, length + 2); // eslint-disable-line no-magic-numbers
};
/**
 * Don't use this.state = {...} in constructor, but rather overwrite getInitialState()
 */


var StoreComponent = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(StoreComponent, _React$PureComponent);

  var _super = _createSuper(StoreComponent);

  function StoreComponent(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, StoreComponent);
    _this = _super.call(this, props, context);
    _this._storesAndPathes = [];
    _this._id = createShortId();
    return _this;
  }

  (0, _createClass2["default"])(StoreComponent, [{
    key: "getForPath",
    value: function getForPath(path, defaultValue) {
      try {
        var value = _json8Patch["default"].get(this.state, path);

        return value === undefined ? defaultValue : value;
      } catch (_unused) {
        return defaultValue;
      }
    }
    /**
     * Call this method in the subclasses CONSTRUCTOR only
     * @param storesAndPathes
     */

  }, {
    key: "addStoresAndPathes",
    value: function addStoresAndPathes(storesAndPathes) {
      this._storesAndPathes = this._storesAndPathes.concat(storesAndPathes);
      this.state = this.getInitialState(); // console.log('init store component', this._id, this)

      var _iterator = _createForOfIteratorHelper(storesAndPathes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var storeAndPathes = _step.value;
          var store = storeAndPathes.store,
              pathes = storeAndPathes.pathes;
          var storeState = store.addListenerComponent(pathes, this);
          var initialState = this.mapStoreToState ? this.mapStoreToState(store, storeState) : null;

          if (initialState) {
            this.state = (0, _assign["default"])(this.state, initialState);
          } else {
            // in case mapToStore is not implemented or we are mapping a store !== DataStore
            this.state = (0, _assign["default"])(this.state, storeState);
          }
        } // console.log('StoreComponent state after adding storesAndPathes', this.state, storesAndPathes)

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      if (this._storesAndPathes) {
        this._storesAndPathes.forEach(function (storeAndPathes) {
          var store = storeAndPathes.store,
              pathes = storeAndPathes.pathes;
          store.removeListenerComponent(pathes, _this2);
        });
      }
    }
  }, {
    key: "getInitialState",
    value: function getInitialState() {
      return {};
    }
    /**
     * Overwrite in subclass.
     *
     * If handled, return the object for setState.
     *
     * You only have to implement it, if the pathes in the subscribed store
     * should mapped to other pathes in the local component state
     * Example Subscribed is /person/prename and /person/familyname and /person/gender
     * and you want map it in the state to firstname and lastname and gender
     *
     * @param changedStore  The store that has changed the state.
     * @param nextStoreState  The new state from that store (contains only the subscribed values).
     * @returns {object}
     */

  }, {
    key: "mapStoreToState",
    value: function mapStoreToState(changedStore, nextStoreState) {
      return null;
    }
  }]);
  return StoreComponent;
}(_react["default"].PureComponent);

var _default = StoreComponent;
exports["default"] = _default;